<template>
    <div>
        <el-form size="large" :model="facility" inline v-loading="saving" label-position="top" ref="facilityForm">
            <el-form-item prop="acronym" label="Acronym" required>
                <el-input v-model="facility.acronym" placeholder="Acronym" />
            </el-form-item>
            <el-form-item prop="owner" label="Facility Leader" required>
                <SelectUser v-model="facility.owner" :with-role="leaderRole" :disabled="!leaderRole" />
            </el-form-item>
            <el-form-item prop="type" label="Facility Type" required>
                <el-select placeholder="Facility Type" v-model="facility.type" value-key="id">
                        <el-option
                            v-for="status in facilityTypes"
                            :key="status.id"
                            :value="status"
                            :label="status.name"
                        />
                    </el-select>
            </el-form-item>
        </el-form>
        <el-form label-position="top" size="large" :model="facility" v-loading="saving" inline>
            <el-form-item>
                <el-button type="primary" @click="validateAndSave">{{saveLabel}}</el-button>
                <el-button v-if="cancel" type="danger" plain @click="this.$refs.facilityForm.clearValidate(); this.facility = {}; $emit('cancel')">{{cancelLabel}}</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
import api from '@/lib/api'
import {mapActions} from 'vuex'

import SelectUser from '@/components/user/SelectUser.vue'

export default {
    name: 'AddFacilityForm',
    components: {SelectUser},
    props: {
        saveLabel: { type: String, default: 'Save' },
        cancelLabel: { type: String, default: 'Cancel' },
        cancel: { type: Boolean, default: false },
    },
    emits: ['save', 'cancel'],
    data: () => ({
        facility: {
            acronym: undefined,
            owner: undefined,
            type: undefined
        },
        candidateUsers: [],
        facilityTypes: [],
        usersLoading: true,
        leaderRole: undefined,
        saving: false
    }),
    computed: {
        leaderOptions () {
            return this.candidateUsers.map(user => {
                return {
                    value: user,
                    label: `${user.first_name} ${user.last_name}`
                }
            })
        }
    },
    methods: {
        ...mapActions('types', ['getFacilityTypes']),
        validateAndSave () {
            this.$refs.facilityForm.validate((valid) => {
                if (valid) {
                    this.$emit('save', this.facility)
                    this.facility = {}
                } else {
                    this.$notify({
                        title: 'Error',
                        message: `Form contains errors. Check all input fields.`,
                        type: 'error'
                    })
                }
            })
        }
    },
    mounted () {
        api.user.getUsersRoles()
        
        .then(response => {
            this.leaderRole = response.data.find (role => {
                return role.name === 'ARS-NF Leader'
            })

            if (!this.leaderRole) {
                this.$notify({
                    title: 'Error',
                    message: `API Server Error: Could not load users.`,
                    type: 'error'
                })

                return
            }
        })

        this.getFacilityTypes().then(types => {
            this.facilityTypes = types
        })
    }
}
</script>